module.exports = __webpack_public_path__ + "img/percentage_blue.ddd18a97.png";